// Centraliza mensagens amigáveis para erros de API
// Sempre retorne strings curtas e úteis

export function mapApiError(error) {
  // Estruturas possíveis: fetch/axios/useAPI
  const status = error?.response?.status || error?.status;
  const data = error?.response?.data || error?.data;
  const code = data?.code || data?.errorCode || error?.code;
  const message = data?.message || data?.error || error?.message;

  // Sem conexão / timeout
  if (error?.message === 'Network Error' || error?.name === 'AbortError') {
    return 'Sem conexão com o servidor. Verifique sua internet e tente novamente.';
  }

  // Casos comuns
  switch (status) {
    case 400:
      return 'Requisição inválida. Revise os dados e tente novamente.';
    case 401:
      return 'Sessão expirada ou não autorizada. Faça login novamente.';
    case 403:
      return 'Você não tem permissão para executar esta ação.';
    case 404:
      return 'Registro não encontrado.';
    case 409:
      return 'Conflito ao processar a solicitação. Já existe um registro semelhante.';
    case 422:
      return 'Dados incompletos ou inválidos. Confira os campos obrigatórios.';
    case 429:
      return 'Muitas solicitações. Aguarde um pouco e tente de novo.';
  }

  // Mapeios específicos vindos do backend (ex: Prisma, MySQL, filtros)
  if (typeof message === 'string') {
    const msg = message.toLowerCase();
    if (msg.includes('não encontrei esse processo')) return 'Processo não encontrado. Confirme o número.';
    if (msg.includes('não gera prazo')) return 'Esse despacho é informativo e não gera prazo.';
    if (msg.includes('falta a data de publicação')) return 'Não foi possível calcular o prazo: falta a data da RPI.';
    if (msg.includes('não foi possível determinar o prazo')) return 'Não foi possível determinar o prazo para este despacho.';
  }

  // Prisma / MySQL genéricos
  if (code === 'P2002') return 'Já existe um registro com essas informações.';

  // 500+ ou desconhecido
  if (!status || status >= 500) {
    return 'Erro no servidor. Tente novamente em instantes.';
  }

  return 'Não foi possível concluir a ação. Tente novamente.';
}

export function successMessage(text) {
  return text || 'Ação realizada com sucesso.';
}
